import { memoryStorage } from "./memoryStorage";

const LOGIN_HISTORY_STORAGE_KEY = "blackroth_login_history_v1";
const MAX_ENTRIES_PER_USER = 25;

const safeParse = (raw) => {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

const getStore = () => {
  const parsed = safeParse(memoryStorage.getItem(LOGIN_HISTORY_STORAGE_KEY));
  return parsed && typeof parsed === "object" ? parsed : {};
};

const setStore = (store) => {
  memoryStorage.setItem(LOGIN_HISTORY_STORAGE_KEY, JSON.stringify(store));
};

const getUserKey = (user) => {
  const id = typeof user?.id === "string" ? user.id.trim() : "";
  if (id) return `id:${id}`;

  const email = typeof user?.email === "string" ? user.email.trim().toLowerCase() : "";
  if (email) return `email:${email}`;

  return "";
};

const getBrowser = () => {
  const ua = navigator.userAgent || "";
  if (/Edg\//i.test(ua)) return "Edge";
  if (/Chrome\//i.test(ua)) return "Chrome";
  if (/Firefox\//i.test(ua)) return "Firefox";
  if (/Safari\//i.test(ua) && !/Chrome\//i.test(ua)) return "Safari";
  return "Browser";
};

const getOS = () => {
  const ua = navigator.userAgent || "";
  if (/Windows/i.test(ua)) return "Windows";
  if (/Mac OS X/i.test(ua)) return "macOS";
  if (/Android/i.test(ua)) return "Android";
  if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";
  if (/Linux/i.test(ua)) return "Linux";
  return "Device";
};

const formatDateTime = (isoValue) => {
  const date = new Date(isoValue);
  if (Number.isNaN(date.getTime())) return "--";
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
  });
};

export const recordLoginHistory = (user) => {
  const key = getUserKey(user);
  if (!key) return;

  const store = getStore();
  const existing = Array.isArray(store[key]) ? store[key] : [];
  const entry = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    at: new Date().toISOString(),
    ip: "--",
    device: `${getBrowser()} on ${getOS()}`,
    ok: true,
  };

  store[key] = [entry, ...existing].slice(0, MAX_ENTRIES_PER_USER);
  setStore(store);
};

export const getLoginHistory = (user) => {
  const key = getUserKey(user);
  if (!key) return [];

  const store = getStore();
  const rows = Array.isArray(store[key]) ? store[key] : [];

  return rows.map((row) => ({
    id: row?.id || `${row?.at || "unknown"}-${row?.device || "device"}`,
    at: formatDateTime(row?.at),
    ip: row?.ip || "--",
    device: row?.device || "--",
    ok: row?.ok !== false,
  }));
};

 